<template>
  <v-container>
    <v-row>
      <v-col class="px-5">
        <br />
        <div class="d-flex align-center">
          <v-icon large>mdi-text-box</v-icon> <span class="text-h6 ml-2">Address Book</span> <br /><br />
        </div>
        <v-divider></v-divider>
        <v-card
          class="pb-4 mt-4"
          color="background"
          max-width="374"
          outlined
          rounded
        >
          <v-btn-toggle
            v-model="toggle_exclusive"
            dense
            mandatory
            style="width:100%"
          >
            <v-btn
              @click="addressType = 'wallet'; selectedAddressObj = null"
              style="width:33.34%"
              color="backgroundLighter"
            >
              <v-icon
                class="mr-1"
                small
                color="white"
              >mdi-wallet</v-icon>
              Wallet
            </v-btn>
            <v-btn
              @click="addressType = 'bank'; selectedAddressObj = null"
              style="width:33.34%"
              checked
              color="backgroundLighter"
            >
              <v-icon
                class="mr-1"
                small
                color="white"
              >mdi-bank</v-icon>
              Bank
            </v-btn>
            <v-btn
              @click="addressType = 'bpay'; selectedAddressObj = null"
              style="width:33.34%"
              color="backgroundLighter"
            >
              <v-icon
                class="mr-1"
                small
                color="white"
              >mdi-receipt</v-icon>
              Bpay
            </v-btn>
          </v-btn-toggle>
          <div class="d-flex flex-row align-center">
            <v-autocomplete
              class="mt-4 mb-4"
              dense
              outlined
              :label="selectedAddressObj ? undefined :'Search...'"
              :items="addresses"
              item-text="address.nickname"
              item-value="id"
              hide-details
              v-model="selectedAddressObj"
              :return-object="true"
              :prepend-inner-icon=" selectedAddressObj? undefined : 'mdi-magnify'"
            >
            </v-autocomplete>
            <v-btn
              outlined
              class="ml-2"
              min-width="36px"
              max-width="36px"
              @click="handleAddClick"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
          <v-card
            v-for="item in filteredAddresses"
            :key="item.id"
            style="background-color:#1A1B23; box-shadow:none"
            onmouseover="this.style.background='#1D1E27';"
            onmouseout="this.style.background='none';"
          >
            <div class="d-flex justify-space-between align-center px-2">
              <v-card-title
                style="font-size:16px"
                class="pa-2"
              >
                {{item.address.nickname}}
              </v-card-title>
              <div>
                <v-icon
                  color="primary"
                  @click="handleEditClick(item)"
                  class="mr-1"
                >mdi-pencil</v-icon>
                <v-icon @click="handleDeleteClick(item)">mdi-trash-can-outline</v-icon>
              </div>
            </div>
            <v-card-text
              v-if="addressType === 'wallet'"
              class="pt-0 pb-2"
            >
              <span class="font-weight-bold mr-2 text-uppercase">{{item.coin}}</span>
              <span>{{item.address.address}}</span>
            </v-card-text>
            <v-card-text
              v-if="addressType === 'bank'"
              class="pt-0 pb-2"
            >
              <span class="mr-2 text-uppercase">{{item.address.bsb.substring(0,3)+'-'+item.address.bsb.substring(3)}}</span>
              <span>{{item.address.accountNumber}}</span>
              <br />
              <span v-if="item.address.accountName">{{item.address.accountName}}</span>
            </v-card-text>
            <v-card-text
              v-if="addressType === 'bpay'"
              class="pt-0 pb-2"
            >
              <span class="mr-2 text-uppercase">{{item.address.biller}}</span>
              <span>{{item.address.ref}}</span>
            </v-card-text>
            <v-divider class="mt-2"></v-divider>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="showDialog"
      width="374"
      @click:outside="handleCloseDialog"
    >
      <v-card
        color="cardIsland"
        class="pb-2"
      >
        <v-card-title class="text-h5">
          {{dialogTitle}}
        </v-card-title>
        <v-divider></v-divider>
        <template v-if="dialogType !== 'delete'">
          <v-card-text class="mt-8">
            <template v-if="addressType === 'wallet'">
              <v-select
                v-if="dialogType === 'add'"
                label="Coin"
                v-model="selectedCoin"
                dense
                placeholder="Select one"
                :items="coins"
                hide-details
              >
                <template v-slot:selection="{ item }">
                  <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
                </template>
                <template v-slot:item="{ item }">
                  <img src="../../assets/icons/btc.svg">&nbsp;&nbsp;{{ item.name }}
                </template>
              </v-select>
              <v-text-field
                v-model="addressInputs[addressType].nickname"
                label="Address nickname"
                placeholder="Enter address nickname"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.wallet.nickname`)"
                @input="hideValidationErrorMsg(`forms.wallet.nickname`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.wallet.nickname`)" />
              <v-text-field
                v-model="addressInputs[addressType].address"
                label="Wallet address"
                placeholder="Enter wallet address"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.wallet.address`)"
                @input="hideValidationErrorMsg(`forms.wallet.address`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.wallet.address`)" />
              <v-text-field
                v-if="addressInputs.coin && dialogType === 'edit'"
                :value="addressInputs.coin.toUpperCase()"
                label="Coin"
                disabled
                hide-details
                class="mt-4"
              ></v-text-field>
            </template>
            <template v-if="addressType === 'bank'">
              <v-text-field
                v-model="addressInputs[addressType].nickname"
                label="Address nickname"
                placeholder="Enter address nickname"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bank.nickname`)"
                @input="hideValidationErrorMsg(`forms.bank.nickname`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.nickname`)" />
              <v-text-field
                v-model="addressInputs[addressType].bsb"
                label="BSB"
                placeholder="Enter BSB"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bank.bsb`)"
                @input="hideValidationErrorMsg(`forms.bank.bsb`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.bsb`)" />
              <v-text-field
                v-model="addressInputs[addressType].accountNumber"
                label="Account number"
                placeholder="Enter account number"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bank.accountNumber`)"
                @input="hideValidationErrorMsg(`forms.bank.accountNumber`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.accountNumber`)" />
              <v-text-field
                v-model="addressInputs[addressType].accountName"
                label="Account name (optional)"
                placeholder="Enter account name (optional)"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bank.accountName`)"
                @input="hideValidationErrorMsg(`forms.bank.accountName`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bank.accountName`)" />
            </template>
            <template v-if="addressType === 'bpay'">
              <v-text-field
                v-model="addressInputs[addressType].nickname"
                label="Address nickname"
                placeholder="Enter address nickname"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bpay.nickname`)"
                @input="hideValidationErrorMsg(`forms.bpay.nickname`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bpay.nickname`)" />
              <v-text-field
                v-model="addressInputs[addressType].biller"
                label="Biller code"
                placeholder="Enter biller code"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bpay.biller`)"
                @input="hideValidationErrorMsg(`forms.bpay.biller`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bpay.biller`)" />
              <v-text-field
                v-model="addressInputs[addressType].ref"
                label="Customer reference number"
                placeholder="Enter customer reference number"
                hide-details
                class="mt-4"
                @blur="handleInputBlur(`forms.bpay.ref`)"
                @input="hideValidationErrorMsg(`forms.bpay.ref`)"
              ></v-text-field>
              <ValidationErrorMsg :validation-data="getInputValidationData(`forms.bpay.ref`)" />
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              @click="handleCloseDialog"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="dialogType === 'edit'"
              color="primary"
              :loading="isLoading"
              @click="updateAddress"
            >
              Save
            </v-btn>
            <v-btn
              v-if="dialogType === 'add'"
              color="primary"
              :loading="isLoading"
              @click="addAddress"
            >
              Save
            </v-btn>
          </v-card-actions>
        </template>
        <template v-if="dialogType === 'delete'">
          <v-card-text class="mt-4">
            Are you sure you want to delete address <span class="font-weight-bold">{{addressInputs[addressType].nickname}}</span>?
          </v-card-text>
          <v-card-actions class="mt-0">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              @click="handleCloseDialog"
            >
              Cancel
            </v-btn>
            <v-btn
              color="primary"
              :loading="isLoading"
              @click="deleteAddress"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import ValidationErrorMsg from '../../components/ValidationErrorMsg.vue'
import { validateValues, _get, _set } from '../../helpers/validation.js';

export default {
  components: {
    ValidationErrorMsg
  },
  data() {
    return {
      toggle_exclusive: 3,
      addressType: 'wallet',
      isLoading: false,
      showDialog: false,
      dialogType: null,
      snackbar: {
        text: "",
        color: "",
        show: false,
      },
      coins: [{ id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' }],
      selectedCoin: { id: 'btc', name: 'Bitcoin', icon: '../../assets/icons/btc.svg' },
      selectedAddressObj: null,
      addressInputs: {
        id: null,
        coin: null,
        wallet: {
          nickname: null,
          address: null,
        },
        bank: {
          nickname: null,
          bsb: null,
          accountNumber: null,
          accountName: null,
        },
        bpay: {
          nickname: null,
          biller: null,
          ref: null,
        },
      },
      forms: {
        wallet: {
          nickname: {
            path: `addressInputs.wallet.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          address: {
            path: "addressInputs.wallet.address",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
        },
        bank: {
          nickname: {
            path: `addressInputs.bank.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          bsb: {
            path: "addressInputs.bank.bsb",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
          accountNumber: {
            path: "addressInputs.bank.accountNumber",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
          accountName: {
            path: "addressInputs.bank.accountName",
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          }
        },
        bpay: {
          nickname: {
            path: `addressInputs.bpay.nickname`,
            validationRulesPath: "requiredOnlyRules",
            showErrorMsg: false,
          },
          biller: {
            path: "addressInputs.bpay.biller",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
          ref: {
            path: "addressInputs.bpay.ref",
            validationRulesPath: "numbersOnlyRules",
            showErrorMsg: false,
          },
        },
      },
      requiredOnlyRules: [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
      ],
      numbersOnlyRules: [
        {
          name: 'required',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
        {
          name: 'numbersOnly',
          validateRule: function (val, rule) {
            return rule.validate(val);
          }
        },
      ],
    }
  },
  computed: {
    ...mapState("address", ["addresses"]),
    ...mapState("auth", ["accessToken"]),
    ...mapGetters("address", ["walletAddresses", "bankAddresses", "bpayAddresses",]),
    addresses() {
      return this[`${this.addressType}Addresses`]
    },
    filteredAddresses() {
      return this.selectedAddressObj ? [this.selectedAddressObj] : this.addresses
    },
    dialogTitle() {
      if (this.dialogType === 'add') return `Add ${this.addressType} address`
      if (this.dialogType === 'edit') return `Edit ${this.addressType} address`
      if (this.dialogType === 'delete') return `Delete ${this.addressType} address`
    }
  },
  methods: {
    ...mapMutations("address", ["setAddresses"]),
    ...mapActions("address", ["getAddresses"]),
    ...mapActions("auth", ["getAccessToken"]),
    handleInputBlur(inputMetadataPath) {
      let { inputMetadata, val } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = true;
      if (inputMetadata === null) {
        return;
      }
      if (val === null || val === undefined) {
        _set(this, inputMetadata.path, "");
      }
    },
    getInputValidationData(inputMetadataPath) {
      let inputMetadata = _get(this, inputMetadataPath);
      if (!inputMetadata) console.log("Couldn't find this path:", inputMetadataPath);
      let val = _get(this, inputMetadata.path);
      let rules = _get(this, inputMetadata.validationRulesPath);
      return { inputMetadata, val, rules };
    },
    hideValidationErrorMsg(inputMetadataPath) {
      let { inputMetadata } = this.getInputValidationData(inputMetadataPath);
      inputMetadata.showErrorMsg = false;
    },
    showValidationErrorMsgsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      for (const item of Object.values(formMetadata)) {
        item.showErrorMsg = true;
      }
    },
    validateInputsByForm(formMetadataName) {
      let formMetadata = _get(this, formMetadataName);
      // sanitizing form
      for (const key of Object.keys(formMetadata)) {
        let inputMetadata = formMetadata[key];
        let val = _get(this, inputMetadata.path);
        if (typeof (val) !== 'boolean') {
          val = val === null || val === undefined ? "" : val;
          val = val.trim();
        }
        _set(this, inputMetadata.path, val);
      }
      // validating form
      let valueAndRulesArray = Object.keys(formMetadata).map((i) => {
        let inputMetadata = formMetadata[i];
        let value = _get(this, inputMetadata.path);
        let rules = _get(this, inputMetadata.validationRulesPath);
        return { value, rules };
      });
      return validateValues(valueAndRulesArray);
    },
    handleAddClick() {
      this.showDialog = true
      this.dialogType = 'add'
    },
    handleEditClick(item) {
      this.showDialog = true
      this.dialogType = 'edit'
      this.setaddressInputs(item)
    },
    handleDeleteClick(item) {
      this.showDialog = true
      this.dialogType = 'delete'
      this.setaddressInputs(item)
    },
    handleCloseDialog() {
      this.showDialog = false
      this.addressInputs = {
        id: null,
        coin: null,
        wallet: {
          nickname: null,
          address: null,
        },
        bank: {
          nickname: null,
          bsb: null,
          accountNumber: null,
          accountName: null,
        },
        bpay: {
          nickname: null,
          biller: null,
          ref: null,
        }
      }
    },
    setaddressInputs(item) {
      this.addressInputs[this.addressType] = { ...item.address }
      this.addressInputs.coin = item.coin
      this.addressInputs.id = item.id
    },
    async addAddress() {
      const isFormValid = this.validateInputsByForm(`forms.${this.addressType}`);
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm(`forms.${this.addressType}`);
        return;
      }
      this.isLoading = true
      const coin = this.addressType === 'wallet' ? this.selectedCoin.id : null
      const address =
      {
        id: null,
        type: this.addressType,
        coin,
        address: this.addressInputs[this.addressType],
      }
      try {
        await this.getAccessToken()
        const response = await fetch(`${process.env.VUE_APP_API_URL}/addresses/`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify(address)
        })
        const data = await response.json()
        if (data.ok) {
          await this.getAddresses()
          this.snackbarSuccess('Successfully saved.')
        }
      } catch (error) {
        this.snackbarError(error)
        console.log(error)
      }
      this.isLoading = false
      this.handleCloseDialog()
    },
    async updateAddress() {
      const isFormValid = this.validateInputsByForm(`forms.${this.addressType}`);
      if (!isFormValid) {
        this.showValidationErrorMsgsByForm(`forms.${this.addressType}`);
        return;
      }
      this.isLoading = true
      const id = this.addressInputs.id
      const newAddressDetails = this.addressInputs[this.addressType]
      try {
        await this.getAccessToken()
        const response = await fetch(`${process.env.VUE_APP_API_URL}/addresses/${id}`, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
          body: JSON.stringify({ newAddressDetails })
        })
        const data = await response.json()
        if (data.ok) {
          await this.getAddresses()
          this.snackbarSuccess('Successfully saved.')
        }
      } catch (error) {
        this.snackbarError(error)
      }
      this.isLoading = false
      this.handleCloseDialog()
    },
    async deleteAddress() {
      this.isLoading = true
      const id = this.addressInputs.id
      try {
        await this.getAccessToken()
        const response = await fetch(`${process.env.VUE_APP_API_URL}/addresses/${id}`, {
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.accessToken}`,
          },
        })
        const data = await response.json()
        console.log(data)
        if (data.ok) {
          await this.getAddresses()
          this.snackbarSuccess('Successfully deleted.')
        }
      } catch (error) {
        this.snackbarError('Server error:', error)
      }
      this.isLoading = false
      this.handleCloseDialog()
    },
    snackbarError(msg) {
      this.snackbar.show = true
      this.snackbar.color = 'red'
      this.snackbar.text = msg
    },
    snackbarSuccess(msg) {
      this.snackbar.show = true
      this.snackbar.color = 'green'
      this.snackbar.text = msg
    }
  },
  async created() {
    await this.getAddresses()
  }
}
</script>
